export default "__VITE_ASSET__BufnQfEY__"